import React, { useState, useEffect } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import CityState from "../../constants/CityState.json";
import * as constants from "../../constants/CONSTANT";
import { MultiSelect } from "react-multi-select-component";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [supplierOption, setOptionSupplier] = useState({});
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionItem] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [branchOption, setOptionBranch] = useState({});
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState({});
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState({});
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [selectedCity, setSelectedCity] = useState({});
  const [cityOption, setOptionCity] = useState({});
  const [selectedToCity, setSelectedToCity] = useState({});
  const [challanData, setChallanData] = useState({});
  const [challanDieselData, setChallanDieselData] = useState({
    challan_advance_date: moment().format("YYYY-MM-DD"),
  });

  const [tripChallanData, setTripChallanData] = useState(
    location.state ? location.state : {}
  );
  const [selectedContacts, setSelectedContact] = useState({});
  const [optionContacts, setOptionsContacts] = useState({});
  const [selectedDieselLtrs, setSelectedDieselLtrs] = useState({});
  const [optionDieselLtrs, setOptionsDieselLtrs] = useState({});
  const [errorMessage, setErrorMessage] = useState();
  const [selectedChallan, setSelectedChallan] = useState({});
  const [challanOption, setOptionChallan] = useState({});
  const [show, setShow] = React.useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (ChallanDataa) => {
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    const challanData = await trasportApi.fetchAllChallan();
    const vechicleRec = await trasportApi.fetchAllVehicles();

    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });

      const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
      const currentYear = new Date().getFullYear();
      let defaultOption;

      if (currentMonth >= 3) {
        // March is the 3rd month
        defaultOption = ar.find(
          (option) => option.label === `${currentYear}-${currentYear + 1}`
        );
      } else {
        defaultOption = ar.find(
          (option) => option.label === `${currentYear - 1}-${currentYear}`
        );
      }

      if (defaultOption) {
        setSelectedFinancialYear(defaultOption);
        setTripChallanData({
          ...tripChallanData,
          financial_year_id: defaultOption.value,
        });
      } else if (location?.state) {
        const acc = ar.find(
          // acc.value === location.state.client_id)
          (acc) => acc.value === location.state.financial_year_id
        );
        setSelectedFinancialYear(acc);
      }
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }
    //Item Api Data
    if (challanData && challanData.length) {
      let ar = [];
      challanData.forEach((item) => {
        ar.push({
          value: item.id,
          label: item.challan_no,
          financial_year_id: item.financial_year_id,
          branch_id : item.branch_id,
        });
      });

      if (location?.state) {
        const acc = ar.find((acc) => acc.value === location.state.challan_id);
        setSelectedChallan(acc);

        const data = {};
        data.challan_id = location.state.challan_id;
        data.financial_year_id = location.state.financial_year_id;
        if (data.challan_id && data.financial_year_id) {
          // setTripChallanData({ ...tripChallanData, challan_no: e.target.value });
          let ChallanDataa = await trasportApi.fetchChallanDetailsForTrip(data);
          if (ChallanDataa.success === true) {
            // fetchData(ChallanDataa.data);
            // setRerender(true);
            console.log("C Trip edit", ChallanDataa.data);
            setChallanData(ChallanDataa.data);
            setErrorMessage();
          }
        }
      }
      setOptionChallan(ar);
    } else {
      setOptionChallan([]);
    }

    if (location?.state) {
      const desielData = await trasportApi.fetchAdvanceDieselChallanByVecId(
        location?.state.vehicle_id
      );
      //Supplier Api Data
      if (desielData && desielData.length) {
        let ar = [];
        desielData.forEach((item) => {
          ar.push({ value: item.id, label: item.qty });
        });

        if (location?.state) {
          // const acc = ar.find(
          //   (acc) => acc.value === location?.state.advance_desiel_id
          // );
          if (location?.state.advance_desiel_id) {
            const initialSelection = location?.state.advance_desiel_id?.map(id => ({
                value: id,
                label: ar.find(user => user.value === id)?.label || '' + " - " + ar.find(user => user.value === id) || '',
            }));
            setSelectedDieselLtrs(initialSelection);
        }
          // setSelectedDieselLtrs(acc);
        }
        setOptionsDieselLtrs(ar);
      } else {
        setOptionsDieselLtrs([]);
      }
    }

    // Vehicle API Data.
    if (vechicleRec && vechicleRec.length) {
      let uniqueVehicles = new Map();

      vechicleRec.forEach((item) => {
        if (!uniqueVehicles.has(item.vehicle_number)) {
          uniqueVehicles.set(item.vehicle_number, {
            value: item.id,
            label: item.vehicle_number,
          });
        }
      });

      let ar = Array.from(uniqueVehicles.values());

      if (location?.state) {
        const acc = ar.find((acc) => acc.value === location.state.vehicle_id);
        setSelectedVechicle(acc);
      }

      setOptionVechicle(ar);
    } else {
      setOptionVechicle([]);
    }
  };

  const handleChangeChallanNo = async (e) => {
    setSelectedChallan(e);
    setTripChallanData({ ...tripChallanData, challan_id: e.value });
    const data = {};
    data.challan_id = e.value;
    data.financial_year_id = e?.financial_year_id;
    data.branch_id = e?.branch_id;
    if (data.challan_id && data.financial_year_id && data.branch_id) {
      // setTripChallanData({ ...tripChallanData, challan_no: e.target.value });
      let ChallanDataa = await trasportApi.fetchChallanDetailsForTrip(data);
      if (ChallanDataa.success === true) {
        // fetchData(ChallanDataa.data);
        // setRerender(true);
        console.log("C Trip", ChallanDataa.data);
        setChallanData(ChallanDataa.data);
        setErrorMessage();

        const desielData = await trasportApi.fetchAdvanceDieselChallanByVecId(
          ChallanDataa.data.vehicle_id
        );
        //Supplier Api Data
        if (desielData && desielData.length) {
          let ar = [];
          desielData.forEach((item) => {
            ar.push({ value: item.id, label: item.qty });
          });

          if (ChallanDataa) {
            const acc = ar.find(
              (acc) => acc.value === ChallanDataa.advance_desiel_id
            );
            setSelectedDieselLtrs(acc);
          }
          setOptionsDieselLtrs(ar);
        } else {
          setOptionsDieselLtrs([]);
        }
      } else {
        setErrorMessage("No Challan Found With this Challan Number !!!!");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Parse input values safely as numbers
    const updatedChallanData = { ...tripChallanData, [name]: value };

    const startKM = parseFloat(updatedChallanData.trip_start_km) || 0;
    const endKM = parseFloat(updatedChallanData.trip_end_km) || 0;

    console.log("start", startKM);
    console.log("end", endKM);

    console.log("");

    // Update trip_running_km only if start and end KM values are valid
    if (name === "trip_start_km" || name === "trip_end_km") {
      updatedChallanData.trip_running_km =
        !isNaN(startKM) && !isNaN(endKM) ? endKM - startKM : 0;
    }

    // Update the state with the modified data
    setTripChallanData(updatedChallanData);
  };


  const checkRequiredFields = () => {
    if (
      challanData.client_name &&
      challanData.email &&
      challanData.phone &&
      challanData.city &&
      challanData.address &&
      challanData.financial_year_id &&
      challanData.district &&
      challanData.state &&
      challanData.country &&
      challanData.pincode &&
      challanData.pan_number &&
      challanData.gst_no &&
      challanData.tin_no &&
      challanData.ecc_no
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }

    // tripChallanData.challan_num = challanData.challan_no;
    // tripChallanData.advance_desiel_id = selectedDieselLtrs.value;
    tripChallanData.advance_desiel_id = selectedDieselLtrs?.map(item => item.value);
    tripChallanData.vehicle_id = challanData.vehicle_id;

    let result2 = {};

    if (tripChallanData.id) {
      result2 = await trasportApi.saveTripChallan(tripChallanData);
      if (result2.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Updated successfully",
        });
        navigate(`/tripchallans`, { state: tripChallanData });
      }
    } else {
      // if(checkChallanNumber && Object.keys(checkChallanNumber).length > 0){
      //   PubSub.publish('RECORD_ERROR_TOAST', { title: 'Challan Number Already Exist', message: "Challan Number Already Exist" });
      //   return;

      // }
      // tripChallanData.vehicle_id = selectedVechicle.value;
      // tripChallanData.advance_desiel_id= selectedDieselLtrs.value;
      console.log("Create Time Item =>", tripChallanData,"selectedDieselLtrs.value",selectedDieselLtrs);
      result2 = await trasportApi.createTripChallan(tripChallanData);
      if (result2.errors) {
        // PubSub.publish("RECORD_ERROR_TOAST", {
        //   title: "Record ERROR",
        //   message: result2.errors[0].msg,
        // });
        // console.log(result2.errors)
        alert(result2.errors);
      }
      if (result2?.id) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/tripchallans`, { state: result2 });
      }
      // } else {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "Record ERROR",
      //     message: result2.errors,
      //   });
      // }
    }
  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/tripchallans/" + tripChallanData.id, {
        state: tripChallanData,
      });
    } else {
      navigate("/tripchallans/");
    }
  };

  //FinancialYear
  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setTripChallanData({ ...tripChallanData, financial_year_id: e.value });
  };

  //Item
  const handleItem = (e) => {
    setSelectedItem(e);
    challanData.item_deduction_rate = itemOption[0].price_deduction;

    setChallanData({ ...challanData, item_id: e.value });
  };

  //Client
  const handleClient = (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, client_id: e.value });
  };

  //Diesel Qty Ltrs.
  const handleDiesel = (selectedOptions) => {
    setSelectedDieselLtrs(selectedOptions);

    // Calculate the total liters and average
    let totalLiters = selectedOptions.reduce((sum, option) => sum + parseInt(option.label), 0);
    console.log("Total Liters:", totalLiters);

    let result = totalLiters > 0 ? tripChallanData.trip_running_km / totalLiters : 0;
    console.log("Trip Average Result:", result);

    // Set the state with advance_deisel_id, total_litrs, and trip_average
    setTripChallanData({
      ...tripChallanData,
      trip_average: result.toFixed(2),
      total_litrs: totalLiters,
    });

    console.log("Selected Options:", selectedOptions);
    console.log("Result:", result);
};


  //   const handleOwnerSelect = (selectedList) => {
  //     // console.log('selectedList', selectedList);
  //     (selectedList?.length != 0) ? setShow(false) : setShow(true);
  //     setSelectedDieselLtrs(selectedList);
  //     //console.log('selectedList.map(item => item.value);', selectedList.map(item => item.value))
  //     tripChallanData.ownerid = selectedList?.map(item => item.value);
  //  };

  //Branch

  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, branch_id: e.value });
  };

  //Vehicle
  const handleVehicle = async (e) => {
    setSelectedVechicle(e);
    
    if (e?.value) {
        const challanData = await trasportApi.fetchChallanByVehicleId(e.value);
        // setChallanData({ ...challanData, vehicle_id: e.value });
        // setOptionChallan(challanByVechicleId ? challanByVechicleId : []);
        if (challanData && challanData.length) {
          let ar = [];
          challanData.forEach((item) => {
            ar.push({
              value: item.id,
              label: item.challan_no,
              financial_year_id: item.financial_year_id,
              branch_id : item.branch_id,
            });
          });
          setOptionChallan(ar);
        } else {
          setOptionChallan([]);
        }
    }
};


  //From City
  const handleCity = (e) => {
    setSelectedCity(e);
    setChallanData({ ...challanData, from_station_id: e.label });
  };

  //To City
  const handleToCity = (e) => {
    setSelectedToCity(e);
    setChallanData({ ...challanData, to_station_id: e.label });
  };

  //Advance Diesel Supplier.
  const handleSupplier = (e) => {
    setSelectedSupplier(e);
    setChallanDieselData({ ...challanDieselData, supplier_id: e.value });
  };

  //Challan Contact (Agent).
  const handleContact = (e) => {
    setSelectedContact(e);
    setChallanData({ ...challanData, agent_id: e.value });
  };

  const handlerAddRow = (e) => {};

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ChallanEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Trip Challan Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                {/* <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Challan Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="challan_no"
                      placeholder="Enter Challan Number"
                      value={tripChallanData.challan_no}
                      onChange={handleChangeChallanNo}
                    />
                  </Form.Group>
                  <Badge
                    variant="danger"
                    className="mt-2 mx-2"
                    style={{ color: "" }}
                  >
                    {errorMessage}
                  </Badge>
                </Col> */}

<Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Vehicle</Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Vehicle Name"
                      value={selectedVechicle}
                      onChange={handleVehicle}
                      options={vechicleOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Vehicle Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Challan Number
                    </Form.Label>
                    <Select
                      className="custom-select username"
                      placeholder="Select Party Name"
                      value={selectedChallan}
                      onChange={handleChangeChallanNo}
                      options={challanOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Client Name.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Badge
                    variant="danger"
                    className="mt-2 mx-2"
                    style={{ color: "" }}
                  >
                    {errorMessage}
                  </Badge>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Challan Date
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="date"
                      name="challan_date"
                      placeholder="Enter Your Challan Date"
                      value={
                        challanData
                          ? moment(challanData.challan_date).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Client / Party Name
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="client_name"
                      placeholder="Client Name"
                      value={
                        challanData.client_name ? challanData.client_name : ""
                      }
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Branch Name
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="branch_name"
                      placeholder="Branch Name"
                      value={
                        challanData.branch_name ? challanData.branch_name : ""
                      }
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Vehicle Number
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="vehicle_number"
                      placeholder="Vehicle Number"
                      value={
                        challanData.vehicle_number
                          ? challanData.vehicle_number
                          : ""
                      }
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      GR Number
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="g_r_no"
                      placeholder="Enter Your GR Number"
                      value={challanData.g_r_no ? challanData.g_r_no : ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      DO Number
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="d_o_no"
                      placeholder="Enter Your d_o_no"
                      value={
                        challanData.d_o_no
                          ? challanData.d_o_no
                          : challanData.d_o_no
                      }
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Consignee
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="consignee"
                      placeholder="Enter Your Consignee"
                      value={challanData.consignee ? challanData.consignee : ""}
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Agent Name (Contacts)
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      // name="g_r_no"
                      placeholder="Agent Name"
                      value={
                        challanData.contact_name ? challanData.contact_name : ""
                      }
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Item</Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      // name="g_r_no"
                      placeholder="Item Name"
                      value={challanData.item_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Item Deduction Rate
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="item_deduction_rate"
                      placeholder="Enter Your Item Deduction Rate"
                      value={challanData.item_deduction_rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      From Station
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="from_station_id"
                      placeholder="From Station Name"
                      value={challanData.from_station_id}
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      To Station
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="text"
                      name="to_station_id"
                      placeholder="To Station Name"
                      value={challanData.to_station_id}
                      // onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Cement Bags
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="cement_bags"
                      placeholder="Enter Your Cement Bagg"
                      value={challanData.cement_bags}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Dispatch Weight (in Ton)
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="dispatch_weight"
                      placeholder="Enter Dispatch Weight"
                      value={challanData.dispatch_weight}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Rate
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="rate"
                      placeholder="Enter Rate (Price ₹)"
                      value={challanData.rate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Total Freight
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      name="total_freight"
                      placeholder="Enter Total Freight"
                      value={challanData.total_freight}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Row className="view-form-header align-items-center row mt-4">
                  <Col lg={9} className="d-flex justify-content-end">
                    Trip Mileage (Vechicle Average Calulation) Master
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAdmissiondate"
                      >
                        Trip Start KM (Kilometers)
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="trip_start_km"
                        placeholder="Enter Trip Start KM"
                        value={tripChallanData.trip_start_km}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAdmissiondate"
                      >
                        Trip End KM (Kilometers)
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="trip_end_km"
                        placeholder="Enter Trip End KM (Kilometers)"
                        value={tripChallanData.trip_end_km}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAdmissiondate"
                      >
                        Trip Running KM (Kilometers)
                      </Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="number"
                        name="trip_running_km"
                        placeholder="Trip Running KM (Kilometers"
                        value={tripChallanData.trip_running_km}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Trip Diesel Ltr. (Liter)
                      </Form.Label>
                      <Select
                        className="custom-select username"
                        placeholder="Select From Station"
                        value={selectedDieselLtrs || []}
                        onChange={handleDiesel}
                        options={optionDieselLtrs}
                        isMulti
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select To Station.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicMileage"
                      >
                        Total Diesel Litrs (Used in this Trip)
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        name="total_litrs"
                        placeholder="Total Diesel Litrs"
                        value={tripChallanData.total_litrs || 0}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicMileage"
                      >
                        Mileage (KM/L)
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        name="trip_average"
                        placeholder="Mileage (KM/L)"
                        value={tripChallanData.trip_average || 0}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Row>
              <Row></Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
